/**
 * Every public sentence about how soon a reply arrives must use this constant.
 * Do not hardcode a second window beside it.
 */
export const REPLY_WINDOW = "24 to 48 hours";
